import { React } from "react";
import "./Experience.css";
import { Briefcase } from "react-bootstrap-icons";
import colorSharp2 from "../assets/img/color-sharp2.png";
import { getGapMonthsWithYear } from "../utils/GetGapMonthsWithYear";

const experiences = [
  {
    company: "Informatics Department, Syiah Kuala University",
    role: "Laboratory Assistant - Pemrograman (Programming) Laboratory",
    duration: `Feb 2022 - May 2022 (${getGapMonthsWithYear(
      "2022-02",
      "2022-05"
    )})`,
    description: [
      "Teaching C and Python programming languages in practical sessions.",
      "Assisting students in understanding the material and solving problems.",
      "Assessing student work",
    ],
  },
  {
    company:
      "PT. ImpactByte Teknologi Edukasi / Skilvul (MSIB) - Studi Independen",
    role: "Mentee - UI/UX Designer",
    duration: `Aug 2022 - Dec 2022 (${getGapMonthsWithYear(
      "2022-08",
      "2022-12"
    )})`,
    description: [
      "Designing Krealolgi's Marketplace and Logistics Integration Feature",
      "Responsible as team leader for coordinating the completion of the project",
      "Responsible for completing the design of the Manual Order Record flow and Goods Delivery flow",
    ],
  },
  {
    company: "Informatics Department, Syiah Kuala University",
    role: "Laboratory Assistant - Pemrograman Berbasis Web (Web-Based Programming) Laboratory",
    duration: `Aug 2022 - Dec 2022 (${getGapMonthsWithYear(
      "2022-08",
      "2022-12"
    )})`,
    description: [
      "Teaching HTML, CSS, JavaScript, and PHP programming languages in practical sessions.",
      "Teaching Laravel framework in practical sessions.",
      "Assisting students in understanding the material and solving problems.",
      "Assessing student work",
    ],
  },
  {
    company:
      "Bangkit led by Google, GoTo, & Traveloka (MSIB) - Studi Independen",
    role: "Cohort - Android Developer",
    duration: `Mar 2023 - Jul 2023 (${getGapMonthsWithYear(
      "2023-03",
      "2023-07"
    )})`,
    description: [
      "Acted as an android programmer/developer in a team of 5 people",
      "Create android-based applications with collaboration with machine learning and cloud computing teams",
      "Responsible for the design, implementation, and testing of the applications created",
    ],
  },
  {
    company: "Pacific Digital Printing Aceh",
    role: "Intern - Fullstack Developer",
    duration: `Jun 2023 - Aug 2023 (${getGapMonthsWithYear(
      "2023-06",
      "2023-08"
    )})`,
    description: [
      "Responsible for the design, implementation, and testing of the system created",
      "Developed a digital printing business management system using Laravel and MySQL",
      "Act as a full-stack developer in a team of 2 people",
    ],
  },
  {
    company: "Informatic's Festival 9.0",
    role: "Executive Committee - Koordinator Lapangan (Event Coordinator)",
    duration: `May 2023 - Sep 2023 (${getGapMonthsWithYear(
      "2023-05",
      "2023-09"
    )})`,
    description: [
      "Responsible for coordinating all parts of the committee",
      "Responsible for the smooth running of the event",
      "Ensure that all parts of the committee carry out their duties properly",
      "Responsible for the technical aspects of the event",
    ],
  },
  {
    company:
      "Himpunan Mahasiswa Jurusan Informatika (HMIF) - Syiah Kuala University",
    role: "Head of Student Welfare Management Department",
    duration: `Jan 2023 - Jan 2024 (${getGapMonthsWithYear(
      "2023-01",
      "2024-01"
    )})`,
    description: [
      "Lead internal department meetings",
      "Monitor and supervise the implementation of work programs",
      "Fully responsible for the department's work program",
      "Coordinate members and departments",
      "Reviewing the main tasks and work functions as well as the development of department members",
      "Making departmental decisions",
    ],
  },
  {
    company: "Informatics Department, Syiah Kuala University",
    role: "Laboratory Assistant - Proyek Perangkat Lunak (Software Project) Laboratory",
    duration: `Feb 2024 - May 2024 (${getGapMonthsWithYear(
      "2024-02",
      "2024-05"
    )})`,
    description: [
      "Teaching Node.js, Adonis, and Vue framework for building fullstack web application in practical sessions.",
      "Assisting students in understanding the material and solving problems.",
      "Assessing student work",
    ],
  },
  {
    company: "Informatics Department, Syiah Kuala University",
    role: "Bachelor's Final Project - Quality Assurance",
    duration: `Mar 2024 - Jul 2024 (${getGapMonthsWithYear(
      "2024-03",
      "2024-07"
    )})`,
    description: [
      "Responsible for testing the an Computer-Based Test application created by the team",
      "Create test cases and test plans",
      "Performing functional testing, volume testing, stress testing, security testing, performance testing, compatibility testing, documentation testing, and procedures testing",
      "Create a test report in the form of sarjana's thesis",
    ],
  },
  {
    company: "PT. Sazanka Henig Solusi",
    role: "IT Developer",
    duration: `Oct 2024 - NOW (${getGapMonthsWithYear("2024-10", "now")})`,
    description: [
      "Develop expertise in Products (include but not limited to UiPath RPA and Business Intelligence) of the Company",
      "Develop Marketing and Communication materials together with Sales team.",
      "Conduct product demo and presentation",
      "Support principal, partner, and customer in all sales and project stages.",
      "Take active part in implementation project",
      "Periodic reporting to the Project and Product Manager.",
    ],
  },
];

export const Experience = () => {
  return (
    <section className="experience" id="experience">
      <h2 className="section-title">Experience</h2>
      <div className="timeline-container">
        {experiences
          .slice()
          .reverse()
          .map((exp, index) => (
            <div key={index} className="timeline">
              <div
                className={`timeline-item ${
                  index % 2 === 0 ? "ganjil" : "genap"
                }`}
              >
                <div className="timeline-icon">
                  <Briefcase size={25} />
                </div>
                <div className="timeline-content">
                  <h3>
                    {exp.role} - {exp.company}
                  </h3>
                  <span className="timeline-date">{exp.duration}</span>
                  <ul>
                    {exp.description.map((desc, index) => (
                      <li key={index}>{desc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
      </div>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
    </section>
  );
};
